<template>
  <div class="scanner">

    <img src="/img/components/scanner/example.png" class="voucher" />

    <h1>{{ $t("ui.cart.voucher.scanner.title") }}</h1>

    <p class="info">
      {{ $t("ui.cart.voucher.scanner.message") }}
    </p>

  </div>
</template>

<style lang="scss">

  .scanner {

    position: relative;
    padding: 25px 25px 100px;

    .voucher {

      display: block;
      margin: 75px auto 100px;
      height: 150px;

    }

    h1 {

      display: block;
      text-align: center;
      text-transform: uppercase;
      margin: 0;
      line-height: 60px;
      font-size: 48px;
      font-weight: 700;
      color: #fff;

    }

    .info {

      margin-top: 25px!important;

    }

  }

</style>

<script>
import { mapGetters } from "vuex";

import Alerts from "@/components/Alerts";

import { LocalStorageService } from '@/store/LocalStorageService';

import { FETCH_INFO, FETCH_CONFIG, CLAIM_VOUCHER, CREATE_ORDER } from "@/store/actions.type";
import { SET_ALERTS, SET_PROPS } from '@/store/mutations.type';

export default {
  name: "Scanner",
  data() {
    return {
      scanResult: false,
      keyListener: {
        enabled: false,
        characters: ''
      }
    };
  },
  created() {
    document.body.addEventListener('keypress', (e) => {
      if (e.keyCode === 13) {
        let voucher = this.keyListener.characters;
        this.$store.dispatch(CLAIM_VOUCHER, voucher).then((result) => {
          this.$store.commit(SET_PROPS, {
            scanner: 'proceed',
            receipt: 'create'
          });
        });
        this.keyListener.enabled = false;
        this.keyListener.characters = '';
        document.body.removeEventListener('keypress', (e) => {});
      }
      else {
        this.keyListener.enabled = true;
      }
      if (this.keyListener.enabled) {
        this.keyListener.characters += String.fromCharCode(e.keyCode);
      }
    });
  },
  computed: {
    ...mapGetters([
      'getProps'
    ])
  }
};
</script>
